import { FC, useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { FormProvider, useForm } from "react-hook-form";
import { Box, Paper, Typography, TextField, CardContent, Grid, Drawer, Stack, Avatar, CircularProgress, Tooltip, SelectChangeEvent, FormControl, InputLabel, InputAdornment, OutlinedInput, Divider, Chip, Autocomplete, Button, Table, TableHead, TableRow, TableBody, TableCell, tableCellClasses, MenuItem, Select, IconButton, TableContainer, TableFooter, ToggleButton, Alert, Badge, Popover, List, ListItem, ListItemText, ListItemButton } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import SettingsIcon from '@mui/icons-material/Settings';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import CustomTextField from "../../components/FormFields/CustomTextField";
// import TableInlineEdit from '../Table/TableInlineEdit';
import DialogClientForm from '../Dialog/CreateClientForm';
import DialogDocumentSettingForm from '../../components/DialogDocumentSettingForm/DialogDocumentSettingForm';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchInvoiceSeqNumber, addInvoice, fetchInvoiceById, updateInvoice, dispatchInvoice } from '../../store/invoiceStore/invoiceThunk';
import { fetchAccountById, fetchAccounts, fetchCounterPartyAccountById, fetchAccountsByName } from "../../store/accountThunk";
import { fetchDocumentSettings } from '../../store/documentSettingStore/documentSettingThunk';
import { InvoiceFormInputs } from "../../utils/invoice.types";
import DocAttachInfo from '../DocumentAttachment/DocAttachInfo';
import PayTo from './PayTo';
import InvoiceButtons from './InvoiceFooterButtons';
import TemplateSelect from './TemplateSelect'
import { StyledBoxLoader } from './Invoice.style';
import { Utils, InvoiceRoute, VocuherCategory, VocuherTypes } from "../../utils/common-utils";
import moment from 'moment';
import './Invoice.css'

import { fetchStates } from '../../store/stateStore/stateThunk';
import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { experimentalStyled as styled } from '@mui/material/styles';
import { toast } from 'react-toastify';
import { on } from 'cluster';
import { AccountCircle, CheckCircleOutline, CurrencyRupee, PersonSearchRounded } from '@mui/icons-material';
import { Divide, SearchCheckIcon } from 'lucide-react';
import { DatePicker } from '@mui/x-date-pickers';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import CheckIcon from '@mui/icons-material/Check';
import BuyerModel from './BuyerModel';
import InvoiceElements  from './InvoiceElements';
import {InvoiceElementsInterface} from './InvoiceElementInterface';
import ItemModel from './ItemModel';
import BankChanges from './BankChange';
import { fetchGstOptions } from '../../store/gstStore/gstThunk';
import { AddBox, Clear, Check, Edit, Delete} from "@mui/icons-material";


interface TableInlineEditProps {
  onChangeLineItemRow: (data: any) => void;
  rowsData?: any[];
  isInvoiceTaxTypeIgst: boolean;
}

interface lineItemSubTotal {
  discount: number;
  tax: number;
  amount: number;
  finalAmount : number;
}

const createLineItem = (
  editable:Boolean, id:number, name: string, description:string, hsnCode: string, mrp:number, unit:string,
  qty:number, appliedRate:number, discountPercentage:number, discount:number, amount:number, taxPercentage:number,
  igst:number, igsttotal:number, cgst:number, cgsttotal:number, sgst:number, sgsttotal:number,
  total:number, _id:string, skuCode: string) => (
  {
    editable, id, name, description, hsnCode, mrp, unit, qty, appliedRate, discountPercentage, discount, amount,
    taxPercentage, igst, igsttotal, cgst, cgsttotal, sgst, sgsttotal, total, _id, skuCode
  }
);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#f5f5f5',
    color: "#000",
    border: '0.01px dashed #d9d4d4',
    borderLeft:'none'
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: "#000",
    border: '0.01px dashed #d9d4d4',
    borderLeft:'none',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: 14,
    border: '0.01px dashed #d9d4d4',
    padding: 5,
    borderLeft:'none',
    borderTop:'none'
  },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    // backgroundColor: theme.palette.action.hover,
    // border: '0.5px dashed #9da7b7',
  },
  // hide last border
  // '&:last-child td, &:last-child th': {
  '&:last-child td, &:last-child th': {
    borderBottom:'none'
  },
}));

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    boxShadow: 'none',
    borderRadius: 7
  },
  toggleButtonGroup: {
    width: '100%',
  },
  toggleButton: {
    width: 15,
    height: 15,
    marginBottom: 2
  },

});


const TableInlineEdit3: FC<TableInlineEditProps> = ({ onChangeLineItemRow, rowsData, isInvoiceTaxTypeIgst }) => {

    

  const [rows, setRows] = useState<any[]>([]);
  const [taxType, setTaxType] = useState<boolean>(isInvoiceTaxTypeIgst || false);
  const classes = useStyles();
  const scrollRef = useRef<null | HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const dispatch1 = useDispatch();
  const [itemModel, setItemModel] = useState(false);
  const [itemAmt, setItemAmt] = useState(0);
  const [len, setLen] = useState(0);
  const [gstOptions, setGstOptions] = useState<any[]>([]);
  const [subTotal, setSubTotal] = useState({
    discount: 0,
    tax: 0,
    amount: 0,
    finalAmount : 0
  })

  useEffect(() => {
    let rowCount = 0;
    let _taxType = false;
    setRows([]);
    // if(rows.length==0 && rowsData) {
    if(rowsData && rowsData.length>0) {
      rowsData.forEach((row) => {
        ++rowCount;
        _taxType = (row.igst > 0 && row.igsttotal ) ? true : false;
        let _row = {
          id:rowCount,
          seqNumber: row.seqNumber ? row.seqNumber : rowCount,
          name: row.name,
          description: row.description,
          hsnCode: row.hsnCode,
          mrp: row.mrp,
          unit: row.unit,
          qty: row.qty,
          appliedRate: row.appliedRate,
          discountPercentage:row.discountPercentage,
          discount:row.discount,
          amount: row.amount,
          taxPercentage: row.taxPercentage,
          igst: row.igst,
          igsttotal: row.igsttotal,
          cgst: row.cgst,
          cgsttotal: row.cgsttotal,
          sgst: row.sgst,
          sgsttotal: row.sgsttotal,
          total: row.total,
          _id: row._id,
          skuCode: row.skuCode
        }
        // let _row = createData(rowCount, row.name, row.description, row.spec, row.hsnCode, row.unit, row.qty, row.appliedRate, row.discount, row.amount, row.igst, row.igsttotal, row.cgst, row.cgsttotal, row.sgst, row.sgsttotal, row.total, row._id, row.skuCode)
        setRows((rows: any) => ([...rows, _row]));
      });
    }

  }, [rowsData])

  useEffect(() => {
    dispatch(fetchGstOptions()).unwrap().then(async (data) => {
      if (data) {
        // if (data.length > 0) {
        //   await data.forEach(async (item: string | any) => {
        //     setGstOptions(([...gstOptions, { label: item.lable, value: item._id }]));
            console.log(data);
            setGstOptions(data);
          // });
        // }
      }
    });
  }, []);

  useEffect(() => {
    setTaxType(isInvoiceTaxTypeIgst ? isInvoiceTaxTypeIgst : false);
  }, [isInvoiceTaxTypeIgst])
  

  useEffect(() => {
    if (rows && rows.length > len) {
      setLen(rows.length);
      dispatch1(()=> {
        scrollRef?.current?.scrollIntoView({ block: 'end', behavior: 'smooth'});
      })
    } else {
      setLen(Number(rows && rows.length));
    }
  }, [rows && rows.length, dispatch1]);

  useEffect(() => {
    let newRows;
    if (rows && rows.length > 0) {
      newRows = rows.map(row => {
        let amount = (row.qty * row.appliedRate) ;
        let _taxPercentage = row.taxPercentage;
        let discountedAmount = (amount * row.discountedPercentage) / 100;
        let taxedAmount = ((amount - (discountedAmount | 0)) * row.taxPercentage)/100;
        row.cgst = taxType ? 0 : Number(Number(_taxPercentage) / 2);
        row.sgst = taxType ? 0 : Number(Number(_taxPercentage) / 2);
        row.igst = taxType ? Number(_taxPercentage).toFixed(2) : 0;
        row.igsttotal = taxType ? Number(taxedAmount).toFixed(2) : Number(0);
        row.cgsttotal = taxType ? Number(0) : Number(Number(taxedAmount) / 2).toFixed(2)
        row.sgsttotal = taxType ? Number(0): Number(Number(taxedAmount) / 2).toFixed(2);
        return row;
      });
      setRows(newRows);
    }
  }, [taxType]);

  useEffect(() => {
    if (rows && rows.length > 0) {

      let sub_discount = Number();
      let sub_tax = Number();
      let sub_amount = Number();
      let sub_finalamount = Number();
      let appliedIgstTaxRates:any = [];
      let appliedCgstSgstTaxRates:any = [];

      rows.map((record:any) => {
        sub_discount = Number(sub_discount + Number(record.discount));
        sub_tax = Number(sub_tax + Number(record.igsttotal) + Number(record.sgsttotal) + Number(record.cgsttotal));
        sub_amount = Number(sub_amount + Number(record.amount));
        sub_finalamount = Number(sub_finalamount + Number(record.total));
        console.log("record.taxPercentage == ", record.taxPercentage);

        if(taxType) {
          if(record.taxPercentage > 0 || record.taxPercentage == 0) {
            appliedIgstTaxRates.push(`@${record.taxPercentage}%`);
            appliedCgstSgstTaxRates.push(``);
          }
        } else {
          if(record.taxPercentage > 0 || record.taxPercentage == 0) {
            appliedIgstTaxRates.push(``);
            // appliedCgstSgstTaxRates.push(record.taxPercentage);
            appliedCgstSgstTaxRates.push(`@${record.taxPercentage/2}%`);
          }
        }
      })
      setSubTotal({
        discount: isNaN(sub_discount) ? 0 : sub_discount,
        tax: isNaN(sub_tax) ? 0 : sub_tax ,
        amount: isNaN(sub_amount) ? 0 : sub_amount,
        finalAmount: isNaN(sub_finalamount) ? 0 : sub_finalamount
      })
      onChangeLineItemRow({ data: rows, values: {
        discount: isNaN(sub_discount) ? 0 : sub_discount,
        tax: isNaN(sub_tax) ? 0 : sub_tax ,
        amount: isNaN(sub_amount) ? 0 : sub_amount,
        finalAmount: isNaN(sub_finalamount) ? 0 : sub_finalamount,
        taxType: taxType,
        appliedIgstTaxRates: Array.from(new Set(appliedIgstTaxRates)),
        appliedCgstSgstTaxRates: Array.from(new Set(appliedCgstSgstTaxRates))
      }});

    } else {
      setSubTotal({
        discount: 0,
        tax: 0,
        amount: 0,
        finalAmount: 0
      })
      onChangeLineItemRow({ data: rows, values: {
        discount: 0,
        tax: 0,
        amount: 0,
        finalAmount: 0,
        taxType: taxType,
        taxes: [],
        appliedIgstTaxRates: [],
        appliedCgstSgstTaxRates: []
      }});
    }
  }, [rows, taxType, itemModel]);

  
  const AddCustomRow = ()=> {
    if(rows && rows.length >= 1) {
      const updatelist = rows.map((c:any) => {
          return {...c, editable: false };
      });
      var s:any[] = [{...rows}];
      var row_index_id = rows.length > 0 ? rows[rows.length - 1].id + 1 : 1
      const _temp_row = createLineItem(true, row_index_id, "", "", "", 0, "Nos", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "", "");
      s = [...updatelist, _temp_row];
      setRows(s);
    } else {
      var row_index_id = rows && rows.length > 0 ? rows[rows && rows.length - 1].id + 1 : 1
      const _temp_row = createLineItem(true, row_index_id, "", "", "", 0, "Nos", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "", "");
      setRows([...rows, _temp_row]);
    }
  }

  const RemoveRow = (id:number)=> {
    const newRows = rows.filter((obj) => obj.id !== id);
    setRows(newRows);
  // onChangeRow(newRows);
    // var s:any[] = [{...rows}];
    // s = s.filter((a:any) => a.id !== Id);
    // setRows(s);
  }

  const Editable = (id:number, editable:boolean) =>{
    const updatelist = rows && rows.map((c:any) => {
      if (c.id === id) {
        return {...c, editable: editable};
      } else {
        return {...c, editable: false};
      }
    });
    var s:any[] = [{...rows}];
    s = updatelist;
    setRows(s);
  }
  
  function getData(data:any) {
    console.log("getData on change called componenet ", data);
    var newRows = rows;
    data.map((e:any) => {
      if(rows.find((i:any) => i.name === e.name))
      {
        console.log("Condition matched i.name === e.name ");
        newRows.map((v:any, index:any)=> {
          if(v.name === e.name){
            console.log("Condition matched v.name === e.name ");
            console.log(v);
            // const _temp_row = createLineItem(false, index, v.name, v.description, v.hsnCode, e.mrp, v.unit, v.qty, v.applliedRate, v.discountPercentage, v.discount, 0, v.taxPercentage, 0, 0, 0, 0, 0, 0, 0, "", "");

            newRows[index] = {...v, qty:Number(v.qty)+Number(e.qty)}
            newRows[index] =  rowReCalculatioForInventory(newRows[index])
            console.log(newRows[index]);
            // newRows[index] = {...v, qty:Number(v.qty)+Number(e.qty)}
          }
        });
        // setRows(s);
      }else {
        console.log("outside if seeting empty rows");
        var row_index_id = newRows && newRows.length > 0 ? newRows[newRows && newRows.length - 1].id + 1 : 1
        // const _temp_row = createLineItem(false, row_index_id, "", "", "", 0, "Nos", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, "", "");
        e =  rowReCalculatioForInventory(e)
        console.log(e);
        newRows = [...newRows, {...e, id: row_index_id}];
      }
    })
    setRows(newRows);
  }

  const setInvoiceItemText =(value:any, field:string, Id:any) => {
    const item:any = [];
    rows && rows.map((o:any) => {
      if (o.id===Id) {
        item.push({...o, [field]: value});
      }else {
        item.push(o);
      }
    })
    var s:any[] = [{...rows}];
    s = item;
    console.log(s);
    setRows(s);
    
  }

  const onChange = (e:any, row:any, type: string) => {
    const value = (type!=='number')? e.target.value : (type==='number' && e.target.value>0) ? e.target.value : 0;
    console.log(value);
    const name = e.target.name;
    // console.log('value and name', value , name);
    const { id } = row;
    const newRows = rows.map(row => {
      if (row.id === id) {

        let _qty = (name==='qty')? value : row.qty;
        let _appliedRate = (name==='appliedRate') ? value : row.appliedRate ;
        let _mrp = (name==='mrp') ? value : (row.mrp || _appliedRate);
        let _discountPercentage = (name==='discountPercentage')? value : row.discountPercentage;
        let _discount = (name==='discount')? value : row.discount;
        let _taxPercentage = (name==='taxPercentage')? value : row.taxPercentage;

        console.log("_discountPercentage =======", _discountPercentage, _mrp);

        let amount = _qty * _mrp ;
        console.log("tiral amount ", amount)
        let discountedPercentage = 0;

        if ((name==='discount') && _discount && _discount > 0) {
          // if (_discount <= discountedAmount) {
            discountedPercentage = (_discount / amount) * 100;
          // } 
          console.log('dis',discountedPercentage);
        }

        discountedPercentage = (discountedPercentage > 0) ? discountedPercentage : _discountPercentage ;

        console.log("discountedPercentage =======", discountedPercentage);
        let discountedAmount = (amount * discountedPercentage) / 100;

        let taxedAmount = ((amount - (discountedAmount | 0)) * _taxPercentage)/100;
        let finalAmt = amount - discountedAmount + taxedAmount;
        
        row.discount = Number(discountedAmount.toFixed(2));
        row.discountPercentage = Number(discountedPercentage).toFixed(2);

        console.log(amount);
        console.log(discountedAmount);
        console.log(Number(12.625));
        console.log("finalAmt ===> ", finalAmt);
        console.log("conversion finalAmt ===> ", Number(finalAmt));
        

        row.amount = Number(amount - discountedAmount ).toFixed(2);
        row.total = Number(finalAmt).toFixed(2);
        row.cgst = taxType ? 0 : Number(Number(_taxPercentage) / 2);
        row.sgst = taxType ? 0 : Number(Number(_taxPercentage) / 2);
        row.igst = taxType ? Number(_taxPercentage).toFixed(2) : 0;
        row.igsttotal =  taxType ? Number(taxedAmount).toFixed(2) : "0";
        row.cgsttotal = taxType ? "" : Number(Number(taxedAmount) / 2).toFixed(2);
        row.sgsttotal = taxType ? "" : Number(Number(taxedAmount) / 2).toFixed(2);
        
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const rowReCalculatioForInventory = (row: any) => {
    let _qty = row.qty;
    let _appliedRate = row.appliedRate ;
    let _mrp = row.mrp || _appliedRate;
    let _discountPercentage = row.discountPercentage ? row.discountPercentage : 0;
    let _discount = (row.discount && row.discount > 0 ) ? row.discount : 0;
    let _taxPercentage = (row.taxPercentage && row.taxPercentage > 0 ) ? row.taxPercentage : 0;

    console.log(`qty=${_qty}, _appliedRate=${_appliedRate}, _mrp=${_mrp}, _discountPercentage=${_discountPercentage}, _discount=${_discount}, _taxPercentage=${_taxPercentage}`);

    let amount = _qty * _mrp ;
    console.log("tiral amount ", amount)
    let discountedPercentage = 0;

    // No Need read and Calculate discountedPercentage from inventory
    // if (_discount && _discount > 0) {
    //   // if (_discount <= discountedAmount) {
    //     discountedPercentage = (_discount / amount) * 100;
    //   // } 
    //   console.log('dis',discountedPercentage);
    // }

    discountedPercentage = (discountedPercentage > 0) ? discountedPercentage : _discountPercentage ;

    console.log("discountedPercentage =======", discountedPercentage);
    let discountedAmount = (amount * discountedPercentage) / 100 | 0;

    let taxedAmount = ((amount - (discountedAmount | 0)) * _taxPercentage)/100;
    let finalAmt = amount - discountedAmount + taxedAmount;
    
    row.discount = Number(discountedAmount.toFixed(2));
    row.discountPercentage = Number(discountedPercentage).toFixed(2);

    // console.log(amount);
    // console.log(discountedAmount);
    // console.log(Number(12.625));
    // console.log("finalAmt ===> ", finalAmt);
    // console.log("conversion finalAmt ===> ", Number(finalAmt));
    

    row.amount = Number(amount - discountedAmount ).toFixed(2);
    row.total = Number(finalAmt).toFixed(2);
    row.cgst = taxType ? 0 : Number(Number(_taxPercentage) / 2);
    row.sgst = taxType ? 0 : Number(Number(_taxPercentage) / 2);
    row.igst = taxType ? Number(_taxPercentage).toFixed(2) : 0;
    row.igsttotal =  taxType ? Number(taxedAmount).toFixed(2) : "0";
    row.cgsttotal = taxType ? "" : Number(Number(taxedAmount) / 2).toFixed(2);
    row.sgsttotal = taxType ? "" : Number(Number(taxedAmount) / 2).toFixed(2);
    
    return row;
  };

  return ( <>
  <ItemModel setVisible={setItemModel} visible={itemModel} itemData={getData} refresh={true}/>
      <Table stickyHeader sx={{ minWidth: 700 }} size='small' aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell width={50}>No</StyledTableCell>
            <StyledTableCell width={250}>Item/Description</StyledTableCell>
            <StyledTableCell align="center" width={100}>HSN/SAC</StyledTableCell>
            {/* <StyledTableCell align="center" width={90}>MRP</StyledTableCell> */}
            <StyledTableCell align="center" width={100}>QTY</StyledTableCell>
            <StyledTableCell align="center" width={130}>PRICE/ITEM (₹)</StyledTableCell>
            <StyledTableCell align="center" width={130}>DISCOUNT</StyledTableCell>
            <StyledTableCell align="center" width={130}>AMOUNT (₹)</StyledTableCell>
            <StyledTableCell align="center" width={150}><><label style={{cursor:'pointer',marginRight:5}}>TAX</label>
            {rows && rows.length ? <> | <label style={{cursor:'pointer',marginLeft:5,marginRight:4}} onClick={() => setTaxType(!taxType)}>IGST</label>
            <ToggleButton
              value="check"
              title='IGST'
              size='small'
              name='taxType'
              className={classes.toggleButton}
              selected={taxType}
              onChange={(e, v) => {
                setTaxType(!taxType);
                // onChange(v, e, 'string');
              }}
            >
              {!taxType ? '' : <CheckIcon style={{fontSize:15}} />}
            </ToggleButton></> : ''}</>
            </StyledTableCell>
            <StyledTableCell align="center" width={150}>FINAL AMOUNT (₹)</StyledTableCell>
            <StyledTableCell align="center" width={110}>
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {console.log("rows", rows)} */}
          {rows && rows.length > 0 && rows.map((e:any, i:any) => 
          <StyledTableRow>
              <StyledTableCell align="center">{e.id}</StyledTableCell>
              <StyledTableCell>
              {e.editable ? 
              <div style={{borderRadius:5,float:'right', fontSize:12,width:100,height:25, color:'#488dff',backgroundColor:'#fef8e6',textAlign:'center',display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                Editable Row</div> : '' }
                {!e.editable ? <p style={{fontSize:13, marginLeft:5}} onDoubleClick={() => Editable(e.id, true)}>
                  {e.name}<br/><span style={{color:'#9da7b7'}}>{(e.description.length > 50) ? `${e.description.substring(0, 50)}...` : e.description}</span>
                </p> : <><TextField 
                  className='c-text-field' 
                  variant="standard" 
                  autoFocus
                  value={e.name}
                  placeholder='Item Name *'
                  onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'name', e.id)}
                  size='small'
                  style={{maxWidth:'100%', width: '55%', marginBottom:3}}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                  }} 
                />
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  multiline
                  maxRows={2}
                  style={{width:'100%'}}
                  value={e.description}
                  onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'description', e.id)}
                  placeholder='Description (Optional)'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                  }} 
                /></>}
              </StyledTableCell>
              <StyledTableCell align="center">
                {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
                  #{e.hsnCode}
                </p> : <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  style={{width:'100%'}}
                  value={e.hsnCode}
                  onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'hsnCode', e.id)}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>#</b></InputAdornment>,
                  }} 
                />}
              </StyledTableCell>
              {/* <StyledTableCell align="center" >
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              ₹ {e.mrp}
                </p> : <TextField
                  className='c-text-field'
                  variant="standard"
                  size='small'
                  value={e.mrp}
                  style={{width:'100%'}}
                  onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'mrp', e.id)}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>₹</b></InputAdornment>,
                  }}
                />}
              </StyledTableCell> */}
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              {e.qty} {e.unit}
                </p> : <> <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='qty'
                  value={e.qty}
                  style={{width:'100%', marginBottom:3}}
                  onChange={v => onChange(v, e, 'number')}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    // endAdornment: <InputAdornment position="end"><b style={{paddingBottom:3,fontSize:12}}>{e.unit}</b></InputAdornment>,
                  }} 
                />
                
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='unit'
                  hidden
                  value={e.unit}
                  style={{width:'100%'}}
                  onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'unit', e.id)}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12,
                    },
                    endAdornment: <InputAdornment position="end"><b style={{paddingBottom:3,fontSize:12}}>Unit</b></InputAdornment>,
                  }} 
                /> </>}
              </StyledTableCell>
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              ₹ {e.mrp || e.appliedRate}
                </p> : <TextField
                  className='c-text-field'
                  variant="standard"
                  size='small'
                  name={e.mrp ? 'mrp' : 'appliedRate'}
                  value={e.mrp || e.appliedRate}
                  style={{width:'100%'}}
                  onChange={v => onChange(v, e, 'number')}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>₹</b></InputAdornment>,
                    // endAdornment: <InputAdornment position="end"><b style={{paddingBottom:3,fontSize:12}}>/ - </b></InputAdornment>,
                  }}
                />}
              </StyledTableCell>
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              @{Number(e.discountPercentage)}%<br/>₹ {Number(e.discount)}
                </p> : <><TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='discountPercentage'
                  value={Number(e.discountPercentage)}
                  style={{width:'100%',marginBottom:3}}
                  onChange={v => onChange(v, e, 'number')}
                  type='number'
                  onInput = {(e) =>{ 
                    var InputElement = (e.target as HTMLInputElement); 
                    InputElement.value = String(Math.max(0, parseInt(InputElement.value) ).toString().slice(0,2)); 
                  }}
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>%</b></InputAdornment>
                  }} 
                />
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='discount'
                  value={Number(e.discount)}
                  onChange={v => onChange(v, e, 'number')}
                  style={{width:'100%'}}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    readOnly: !e.editable,
                    style:{
                      fontSize:12
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10}}>₹</b></InputAdornment>
                  }} 
                /></>}
              </StyledTableCell>
              
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              ₹ {e.amount}
                </p> : <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='amount'
                  value={e.amount}
                  style={{width:'100%',textAlign:'right'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:12}}>₹</b></InputAdornment>,
                  }} 
                />}
              </StyledTableCell>

              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              @{Number(e.taxPercentage)}%<br/>₹ {taxType ? e.igsttotal : Number(e.cgsttotal)+Number(e.sgsttotal)}
                </p> : <><Select
                        className='c-text-field' 
                        disableUnderline
                        size='small'
                        name='taxPercentage'
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1.5px solid #e9ecf1",
                              // width: 150,
                              boxShadow: 'none',
                              borderRadius: '5px'
                            }
                          }
                        }}
                        onChange={v => onChange(v, e, 'number')}
                        variant='outlined'
                        defaultValue={e.taxPercentage > 0 ? e.taxPercentage : 0}
                        sx={{
                          boxShadow: "none",
                          fontSize:12,
                          height:26,
                          width:'100%',
                          marginTop:'4px',
                          '& .MuiOutlinedInput-input': {p: 0,m:0},
                          '& .MuiSelect-select': { p:0 },
                          marginBottom:'3px',
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                        }}
                        IconComponent={()=> null}
                        readOnly={!e.editable}
                      >
                        {gstOptions && gstOptions.map((option)=> 
                          <MenuItem value={option.value}>{option.lable}</MenuItem>
                        )}
                      </Select>
                {taxType ? <>
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  name='igsttotal'
                  size='small'
                  value={e.igsttotal}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10,marginRight:-5}}>IGST | ₹</b></InputAdornment>,
                  }} 
                />
                </> : <>
                {/* <Typography> dd -- {e.cgst}</Typography> */}
                <TextField 
                  className='c-text-field' 
                  style={{width:'100%',marginBottom:3}}
                  variant="standard" 
                  size='small'
                  name='cgsttotal'
                  value={Number(e.cgsttotal)+Number(e.sgsttotal)}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10,marginRight:-5}}>₹ </b></InputAdornment>,
                  }} 
                />
                
                {/* <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='sgsttotal'
                  value={e.sgsttotal}
                  onDoubleClick={() => Editable(e.id, true)}
                  type='number'
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:10,marginRight:-5}}>SGST {e.taxPercentage && e.taxPercentage/2}% | ₹</b></InputAdornment>,
                  }} 
                /> */}
                </> }</>}
              </StyledTableCell>
              <StyledTableCell align="center">
              {!e.editable ? <p style={{fontSize:13}} onDoubleClick={() => Editable(e.id, true)}>
              ₹ {e.total}
                </p> : <TextField 
                  className='c-text-field' 
                  variant="standard" 
                  size='small'
                  name='total'
                  value={e.total}
                  style={{width:'100%',textAlign:'right'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:12
                    },
                    readOnly: true,
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:12}}>₹</b></InputAdornment>,
                  }} 
                />}
              </StyledTableCell>
              
              <StyledTableCell align="center" >
                <IconButton size='small' onClick={() => Editable(e.id, true)} style={{marginBottom: '3px', marginRight: '5px', color:'#488dff',backgroundColor:'#f1f0fc',border:'1px solid #488dff',borderRadius:10 }}>
                  <ModeEditOutlineOutlinedIcon style={{fontSize:15}}/>
                </IconButton>
                <IconButton aria-label="Delete" size='small' onClick={() => RemoveRow(e.id)} style={{color:'#c33b3b',backgroundColor:'#fbecec',border:'1px solid #c33b3b',borderRadius:10 }}>
                  <Delete style={{fontSize:15}}/>
                  {/* <RemoveCircleOutlineOutlinedIcon style={{color:'#DC3545'}} /> */}
                </IconButton>
              </StyledTableCell>
          </StyledTableRow>)}
        </TableBody>
        <div style={{scrollMargin:25}} ref={scrollRef}></div>
        {rows && rows.length ?
        <TableFooter>
          <TableRow>
            <StyledTableCell colSpan={2} style={{padding:4}}>
              <Button onClick={()=> setItemModel(true)} size='small' style={{color:'#545454',border:'1px dashed grey',borderRadius:5,width:'100%' }} variant='outlined'>
                <ArrowCircleDownIcon style={{fontSize:'18px'}}/>
                &nbsp;Load From Inventory
              </Button>
            </StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell align="right">SUBTOTAL</StyledTableCell>
            <StyledTableCell align="center" style={{fontSize:14}}>₹ {subTotal && Number(subTotal.discount).toFixed(2)}</StyledTableCell>
            <StyledTableCell align="center" style={{fontSize:14}}>₹ {subTotal && Number(subTotal.amount).toFixed(2)}</StyledTableCell>
            <StyledTableCell align="center" style={{fontSize:14}}>₹ {subTotal && Number(subTotal.tax).toFixed(2)}</StyledTableCell>
            <StyledTableCell align="center" style={{fontSize:14}}>₹ {subTotal && Number(subTotal.finalAmount).toFixed(2)}</StyledTableCell>
          </TableRow>
        </TableFooter> : ''}
    </Table>
    {rows && rows.length ? '' :
    <Grid container spacing={0} p={0.5}>
      <Grid item xs={12} >
        <Box onClick={()=> setItemModel(true)} sx={{ p: 1,cursor:'pointer', border: '1px dashed #488dff', borderRadius:'10px', margin:'5px',maxWidth:'100%',color:'#488dff',textAlign:'center',display: 'flex',justifyContent: 'center',alignItems: 'center'}} >
          <AddCircleOutlineOutlinedIcon style={{fontSize:'16px'}}/>&nbsp;CLICK TO ADD ITEM FROM INVENTORY
        </Box>
      </Grid>
      {/* <Grid item xs={2.9} >
        <Box sx={{ p: 1,cursor:'pointer', border: '1px dashed #488dff', borderRadius:'10px', margin:'5px',maxWidth:'100%',color:'#488dff',textAlign:'center',display: 'flex',justifyContent: 'center',alignItems: 'center'}} 
        onClick={AddCustomRow}>
          <AddCircleOutlineOutlinedIcon style={{fontSize:'16px'}}/>&nbsp;ADD EMPTY ROW
        </Box>
      </Grid> */}
    </Grid>}
    </>
)
}

export default TableInlineEdit3;